const convertGMTDateToISO = (date) => JSON.parse(JSON.stringify(date));

export { convertGMTDateToISO };
